class BESSAppProjectSiteTypeDependency extends BESSAppProjectDependency {

    constructor(dependencyHandler) {
        super();
        this.subscribeToEvents(
            BESSAppProjectSiteTypeDependencyEvent.name,
            (x) => dependencyHandler.handle(x)
        );
    }
}

function siteTypeQualifies(siteTypes) {
    return function (value) {
        return _.indexOf(siteTypes, value) >= 0;
    }
}